import React from "react";
import { describe } from "@/lib/clonerApi";

const SKIP = ["SCRIPT", "STYLE", "BASE", "META", "LINK", "TITLE"];

const flatten = (root) => {
  const out = [];
  const walk = [{ el: root, depth: 0 }];
  while (walk.length && out.length < 600) {
    const { el, depth } = walk.shift();
    if (!el || SKIP.indexOf(el.tagName) !== -1) continue;
    out.push({ el, depth });
    if (depth < 12) {
      const kids = Array.from(el.children).slice(0, 60);
      for (let i = kids.length - 1; i >= 0; i -= 1) {
        walk.unshift({ el: kids[i], depth: depth + 1 });
      }
    }
  }
  return out;
};

/** Árbol de capas de la página abierta. */
export const LayersPanel = ({ doc, selected, onPick, version }) => {
  if (!doc || !doc.body) return <p className="text-xs text-white/40 p-4">Abre una página.</p>;
  const nodes = flatten(doc.body);
  return (
    <div className="p-2" data-testid="layers-panel" key={version}>
      {nodes.map((n, i) => (
        <button key={i} onClick={() => onPick(n.el)} data-testid={`layer-${i}`}
          style={{ paddingLeft: `${n.depth * 10 + 4}px` }}
          className={`w-full text-left px-1 py-0.5 text-[10px] font-mono truncate rounded ${
            selected === n.el ? "bg-[#C2620E]/30 text-white" : "text-white/55 hover:bg-white/[0.05]"}`}>
          {describe(n.el)}
        </button>
      ))}
    </div>
  );
};
